import { useState } from 'react'
import { useInterval } from './useInterval'

export const useRerenderInterval = intervalMs => {
  const setDate = useState(null)[1]
  useInterval(() => setDate(Date.now()), intervalMs)
}
